export interface ResponseMessage {
    /**
     * *True* if request succeeded.
     */
    ok?: boolean;

    /**
     * Error message if request failed.
     */
    message?: string;
}

export interface InfoRecordResponseBase {
    ok: boolean;
    date_inserted?: string;
    user_id_inserted?: string;
}
